<template>
  <div>
    <ProjectMainProjects :query="{ mainProjectId: mainProjectId }" />
  </div>
</template>

<script>
import ProjectMainProjects from "@/components/ProjectMainProjects/index.vue";
export default {
  components: {
    ProjectMainProjects,
  },
  data() {
    return {
      mainProjectId: this.$route.params.mainProjectId,
    };
  },
};
</script>

<style></style>
